var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLendLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 954,
    height: 243,
    viewBox: "0 0 954 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_5474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M658.53 238.452L492.313 52.114V238.452H458.566V4.55469H491.943L652.723 184.553V4.55469H686.47V238.452H658.53Z",
    fill: "#4AFFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 238.452V4.55469H35.1031V204.894H178.948V238.452H0Z",
    fill: "#4AFFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.127 238.465V4.53538L836.583 4.07471C901.319 4.07471 954 56.7468 954 121.494C954 186.24 901.319 238.912 836.576 238.919L727.127 238.458V238.465ZM762.237 204.894H836.57C882.554 204.894 919.967 167.483 919.967 121.5C919.967 75.5174 882.554 38.1059 836.57 38.1059H762.237V204.894Z",
    fill: "#4AFFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.031 243C241.037 243 186.527 188.492 186.527 121.5C186.527 54.5083 241.037 0 308.031 0C375.026 0 429.53 54.5083 429.53 121.5C429.53 124.919 429.367 128.449 429.056 132.011H222.499L223.278 136.456C230.506 177.663 266.154 207.567 308.031 207.567C333.168 207.567 356.825 196.699 373.222 177.695H415.748C394.9 217.559 353.263 243 308.031 243ZM308.031 35.4261C270.696 35.4261 237.819 59.2642 226.224 94.7422L224.601 99.7058H391.468L389.846 94.7422C378.251 59.2642 345.373 35.4261 308.038 35.4261H308.031Z",
    fill: "#4AFFCE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_5474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 954,
    height: 243,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLendLogo);
export default __webpack_public_path__ + "static/media/lend_logo.14b29a40.svg";
export { ForwardRef as ReactComponent };